import React, { Component } from 'react';
import {Route, Switch} from 'react-router'
import {createStore, combineReducers, applyMiddleware, compose} from 'redux'
import {ConnectedRouter, routerReducer, routerMiddleware, push} from 'react-router-redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory'

import logger from 'redux-logger'
import Error from './widgets/Error';
import AuthCallback from './chrome/AuthCallback';
import LoggedOut from './chrome/LoggedOut';
import reducer from './reducer';
import Chrome from './chrome/Chrome';
import * as msal from 'msal';

const history = createHistory();
const router = routerMiddleware(history);

const store = createStore(
	reducer(),
	process.env.NODE_ENV === 'production'
		? applyMiddleware(router, thunk)
		: (
			window.__REDUX_DEVTOOLS_EXTENSION__
				? compose(applyMiddleware(router, thunk, logger), window.__REDUX_DEVTOOLS_EXTENSION__())
				: applyMiddleware(router, thunk, logger)
		)
);

/**
 * Prevent navigation on dirty state changes
 */
window.onbeforeunload = e => {
	const {dirty} = store.getState();
	
	if (dirty && dirty.keys && Object.keys(dirty.keys).length) {
		e.returnValue = 'You have unsaved changes, are you sure you want to proceed?';
		return e.returnValue;
	}
};

/**
 * Prevent history change on dirty state changes
 */
window.onpopstate = () => {
	const {dirty, router} = store.getState();
	
	if (dirty && dirty.keys && Object.keys(dirty.keys).length) {
		// Redux store still has previous pathname. Overwrite DOM state with it.
		store.dispatch(push(router.location.pathname))
	}
};

class App extends Component {
	constructor(props) {
		super(props);
		this.appConfig = {
			login: {
				auth: {
					clientId: process.env.REACT_APP_MS_CLIENT_ID,
					authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MS_TENANT_ID}`
				}
			},
			scopes: {
				scopes: ['user.read']
			}
		};
		this.msalService = new msal.UserAgentApplication(this.appConfig.login);
	}

	login = () => this.msalService.loginPopup(this.appConfig.scopes);

	getToken = () => this.msalService.acquireTokenSilent(this.appConfig.scopes);

  render() {
    return (
	    <Provider store={store}>
		    <ConnectedRouter history={history}>
					<Switch>
						<Route path="/auth/callback">
							<div className="App">
								<Error />
								<AuthCallback getToken={this.getToken} />
							</div>
						</Route>
						<Route path="/loggedout">
							<div className="App">
								<Error />
								<LoggedOut login={this.login} />
							</div>
						</Route>
						<Route component={Chrome}/>
					</Switch>
		    </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js